import React, { useContext,useEffect, useRef} from "react";
import PdfView from "./pdfView";
import { PayLoadCtx } from "../../../../lib/context";
import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../../ui-styles/list/AttachmentList.css";
import "../../../../ui-styles/fileView/FileView.css";

const UploadFileView = (props) => {
    const { payload } = useContext(PayLoadCtx);
    const { data } = props;
    const imageTypes = ["image/gif", "image/jpeg", "image/jpg", "image/png", "image/avif"];
    const youtubePlayerRef = useRef(null); 

    const downloadFile = async (data) => {
        const response = await fetch(data.url);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        const formattedTime = `${hours}:${minutes}`;
        const sender = data.senderName;
        link.style.display = 'none';
        link.href = url;
        link.download = `${payload.firstName}_${sender}_(${formattedDate})(${formattedTime})`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (youtubePlayerRef.current && !youtubePlayerRef.current.contains(event.target)) {
                props.handleClose()  // Close the player when clicking outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    function extractYoutubeID(url) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    }
    
    return (
        <div className={props.open ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className='patfileReportsView'>
                <div className="fvHdrCntnr">
                    <div className="fileViewHeader">
                        <div className="fileTxtRow">
                            <span className="fileHdrTxtL">{data.uploadname.substr(0)}</span>
                        </div>
                    </div>
                    <div className="hdrActionGroup" onClick={props.handleClose}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
                {data && data.uploadtype !== "application/pdf" && data.uploadtype !== "youtubeUrl" ? (
                    <div className="mediaBdyCntnr2 ">
                        <div className="mediaBdy2">
                            <div className="mediaViewBox alignCenter justifyCenter">
                                {data.uploadtype.startsWith("video") ? (
                                    <div className="mediaFileContainer">
                                        <video 
                                            style={{ width: "100%", height: "100%", objectFit: "contain", overflow: "hidden" }} 
                                            controls
                                        >
                                            <source 
                                                src={data.uploadkey
                                                    ? `https://${process.env.REACT_APP_s3}.s3.${process.env.REACT_APP_s3Region}.amazonaws.com/${data.uploadkey}`
                                                    : data.url} 
                                                type={data.uploadtype}
                                            />
                                        </video>
                                    </div>
                                ) : ( data.uploadtype.startsWith("image") ? (
                                    <div className="mediaFileContainer">
                                        <img style={{ width: "100%",height:'100%',objectFit:'contain',overflow:'hidden'}}
                                                src={data.uploadkey
                                                    ? `https://${process.env.REACT_APP_s3}.s3.${process.env.REACT_APP_s3Region}.amazonaws.com/${data.uploadkey}`
                                                    : data.url}
                                                alt="mediafile"
                                            />
                                    </div>
                                    ) : (
                                    <button style={{color:'#fff'}} className="downloadfile" onClick={() => downloadFile(data)}>
                                        Download File
                                    </button> 
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                ) : data && data.uploadtype === "application/pdf" ? (
                    <PdfView data={data} />
                ) : null}
            </div>
            {props.data?.uploadtype === "youtubeUrl"  && (
                <div className="youtubeVideoContainer">
                                <div className="youtubeContainer" ref={youtubePlayerRef}>
                                    <iframe
                                        width="100%"
                                        height="500"  // Adjust height based on the aspect ratio
                                        // src={`https://www.youtube.com/embed/${extractYoutubeID(props.data.url)}`}
                                        src={`https://www.youtube.com/embed/${extractYoutubeID(props.data.url)}`}

                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                     <div className="closeButton" >
                                        <div className="hdrActItem close" style={{ height: "30px", width: "30px" }} onClick={props.handleClose} ></div>
                                    </div>
                                </div>
                            </div>
            )}
        
        </div>
    );
};

export default UploadFileView;
